<template>
  <div class="main-view">
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" :size="subUnitSize">
        <el-form-item label="用工单位" prop="company_id">
          <el-select v-model="table.params.company_id" placeholder="请选择" filterable @change="handleCompanyChange">
            <el-option
              v-for="item in companyOpt"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="基本工资:">
          <span>{{selCurCompany.salary}}元</span>
        </el-form-item> -->
        <el-form-item label="月份筛选" prop="date">
          <el-date-picker
            v-model="table.params.date"
            type="month"
            placeholder="选择月"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="员工名称" prop="name">
          <el-input clearable v-model.trim="table.params.name" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input clearable v-model.trim="table.params.phone" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询
          </el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="btnAdd" style="display: flex;align-items: center;">
        <!-- <el-button :size="subUnitSize" type="primary" icon="el-icon-plus" @click="showEdit">创建</el-button> -->
        <el-button :size="subUnitSize" type="primary" icon="el-icon-download" @click="handleExport">导出</el-button>
        <div style="margin-left: 10px;" v-if="all_total != 0"> 
          <span style="margin-right:20px;">单位部分：{{company_total}}元</span>
          <span style="margin-right:20px;">员工部分：{{employee_total}}元</span>
          <span style="margin-right:20px;">总计：{{all_total}}元</span>
        </div>
      </div>
    </div>

    <VTable
      has-pagionation
      title=''
      addText='添加'
      :field="field"
      :loading="table.loading"
      :element-loading-text="table.loadingText"
      :data="table.data"
      :page='table.params.page'
      :pageSize='table.params.count'
      :total='table.total'
      :tree-props="{children: 'children', hasChildren: 'has_child'}"
      :hasPagionation="true"
      :default-expand-all="true"
      :showOverflowTooltip="true"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <!-- 五险缴纳方式 -->
      <template v-slot:is_insurance="{row}">
        <span>{{row.is_insurance ===1 ? '是' : '否'}}</span>
      </template>
      <template v-slot:insurance_pay_type="{row}">
        <span>{{payType[row.insurance_pay_type]}}</span>
      </template>
      <!-- 公积金缴纳方式 -->
      <template v-slot:is_fund="{row}">
        <span>{{row.is_fund ===1 ? '是' : '否'}}</span>
      </template>
      <template v-slot:fund_pay_type="{row}">
        <span>{{payType[row.fund_pay_type]}}</span>
      </template>
       <!-- 责任险缴纳方式 -->
       <template v-slot:is_duty="{row}">
        <span>{{row.is_duty ===1 ? '是' : '否'}}</span>
      </template>
      <template v-slot:duty_pay_type="{row}">
        <span>{{payType[row.duty_pay_type]}}</span>
      </template>
       <!-- 大病险缴纳方式 -->
       <template v-slot:is_illness="{row}">
        <span>{{row.is_illness ===1 ? '是' : '否'}}</span>
      </template>
      <template v-slot:illness_pay_type="{row}">
        <span>{{payType[row.illness_pay_type]}}</span>
      </template>

      <template v-slot:fund_level_base="{row}">
        <span>{{row.fund_level_base}};{{row.fund_level_company_rate}}%,{{row.fund_level_employees_rate}}%</span>
      </template>
      
      <template v-slot:action="{row}">
        <el-button type="text" @click="showDetail(row)">查看</el-button>
      </template>
    </VTable>

    <edit ref="edit" @refresh="getTable"></edit>
    <detail ref="detail"></detail>
    
  </div>
</template>

<script>
import Edit from './components/Edit.vue'
import Detail from './components/Detail.vue'
import VTable from '@/components/VTable';
import {exportData} from "@/util/index"
import { mapGetters } from 'vuex'
import { mixinTable } from '@/mixins/table.js'
export default {
  name: '',
  mixins:[mixinTable],
  components: {
    Edit,
    Detail,
    VTable
  },
  computed: {
    ...mapGetters({
      companyOpt: 'companyList' // 获取企业列表
    })
  },
  data() {
    return {
      tableLoading: true,
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      field: [
        { name: "id", label: "ID"},
        { name: "company_name", label: "用工单位", width:"160", hidden: false },
        { name: "settlement_month", label: "缴纳月份", width:"120", hidden: false },
        { name: "employee_name", label: "员工姓名", hidden: false },
        { name: "phone", label: "联系电话", width:"120", hidden: false },
        { name: "is_insurance", label: "缴纳五险", hidden: false},
        { name: "insurance_level_name", label: "选择档次", width:"160", hidden: false},
        { name: "company_insurance_fee", label: "单位部分/元", width:"120",  hidden: false},
        { name: "person_insurance_fee", label: "员工部分/元", width:"120", hidden: false},
        { name: "insurance_pay_type", label: "五险缴纳方式", width:"180", hidden: false},
        { name: "is_fund", label: "缴纳公积金", width:"120", hidden: false},
        { name: "fund_level_base", label: "缴纳基数", width:"180", hidden: false},
        { name: "company_accumulation_fee", label: "单位部分/元", width:"120", hidden: false},
        { name: "person_accumulation_fee", label: "员工部分/元", width:"120", hidden: false},
        { name: "fund_pay_type", label: "公积金缴纳方式", width:"180", hidden: false},
        { name: "is_duty", label: "缴纳雇主责任险", width:"120", hidden: false},
        { name: "company_duty_fee", label: "单位部分/元", width:"120", hidden: false},
        { name: "person_duty_fee", label: "员工部分/元", width:"120", hidden: false},
        { name: "created_at", label: "生成时间", width:"140", hidden: false},
        // { name: "is_illness", label: "大病医疗险", width:"120", hidden: false},
        // { name: "company_illness_fee", label: "单位部分/元", width:"120", hidden: false},
        // { name: "person_illness_fee", label: "员工部分/元", width:"120", hidden: false},
        { name: "action", label: "操作",width: "120", fixed:"right", hidden: false }
      ],
      table: {
        loading: false,
        loadingText: '查询明细请先选择企业',
        params: {
          date: '',
          company_id: '',
          year: '',
          month: '',
          name: '',
          phone: '',
          page: 1,
          count: 10
        },
        data: [],
        total: 0,
      },
      selCurCompany: {},
      rowId: '',
      payType: {
        1: '单位全额',
        2: '员工全额',
        3: '单位员工各自缴纳'
      },
      company_total: '',
      employee_total: '',
      all_total: '',
    }
  },
  created() {
    this.getTable();
  },
 
  methods: {
    // payType(t){
    //   return {
    //     1: '单位全额',
    //     2: '员工全额',
    //     3: '单位员工各自缴纳'
    //   }[t]
    // },
    getTable() {
      if(this.table.params.date) {
        let _selDate = this.table.params.date
        this.table.params.year = this.$moment(_selDate).format('YYYY') || ''
        this.table.params.month = this.$moment(_selDate).format('MM') || ''
      } else if(this.table.params.date == null) {
        this.table.params.year = '';
        this.table.params.month = '';
      }
      this.$http.post('/admin/finance/paymentDetailList', this.table.params).then(res => {
        if(res.code === 1) {
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.company_total = res.data.company_total;
          this.employee_total = res.data.employee_total;
          this.all_total = res.data.all_total;

          // let _date = `${res.data.year}-${res.data.month}`
          // this.table.params.date = _date
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    showEdit(row) {
      let dom = this.$refs.edit
      dom.toggle(true)
      if (!!row.id) {
        dom.getDetail(row)
      }
      dom = null
    },
    // 删除
    remove(row) {
      this.$confirm("是否删除此条记录？", "删除", {
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            console.log('删除接口');
            done()
          } else {
            done()
          }
        }
      })
    },
    showDetail(row) {
      let dom = this.$refs.detail
      dom.toggle(true)
      dom.getDetail(row)
      dom = null
    },
    // 重置
    reset() {
      this.$refs.elFormDom.resetFields()
      this.table.params.date = '';
      this.table.params.year = '';
      this.table.params.month = '';
      this.table.params.page = 1;
      this.getTable();
    },
    handleCompanyChange(id) {
      this.table.params.date = ''; // 选择企业清空上次企业的月份
      this.table.loading = false;
      this.companyfilter(id);
      this.getTable(); // 选择企业之后查询缴纳明细列表
    },
    // 根据企业带出企业福利
    companyfilter(id) {
      let arr =  this.companyOpt.filter(item => {
        return item.id == id;
      })
      this.selCurCompany = arr[0]
    },
    // 导出
    handleExport() {
      if(this.table.data.length > 0) {
        exportData(this.table.params,'/admin/finance/exportPaymentDetail')
      } else {
        this.$message.warning('没有需要导出的缴纳明细数据！')
      }
    }
    
  }
}
</script>
